import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ImageGallery from 'react-image-gallery';

const ImagePopup = (props) => {
    const{imagePopup,mediaImages,startIndex,setImagePopup}=props;

    const handleImagePopupClose = () => {
        setImagePopup(false)
    }

    return (
        <Dialog open={imagePopup} onClose={handleImagePopupClose}>
            <DialogContent>
                <ImageGallery items={mediaImages}
                    startIndex={startIndex}
                    showPlayButton={false}
                    showFullscreenButton={false}
                    slideInterval={1000}
                    slideOnThumbnailOver={false}
                    showThumbnails={false}
                    additionalClass="galleryImage"
                />
            </DialogContent>
        </Dialog>
    )
}
export default ImagePopup;